import type { BibleBookId, BibleBookMeta } from "./bibleRegistry.types";

/** All 66 books of the Protestant Bible — nothing omitted. */
export const PROTESTANT_BOOKS: readonly BibleBookMeta[] = [
  {
    id: "genesis",
    name: "Genesis",
    testament: "ot",
    section: "Pentateuch",
    canonicalOrder: 1,
    scriptureChapters: 50,
  },
  {
    id: "exodus",
    name: "Exodus",
    testament: "ot",
    section: "Pentateuch",
    canonicalOrder: 2,
    scriptureChapters: 40,
  },
  {
    id: "leviticus",
    name: "Leviticus",
    testament: "ot",
    section: "Pentateuch",
    canonicalOrder: 3,
    scriptureChapters: 27,
  },
  {
    id: "numbers",
    name: "Numbers",
    testament: "ot",
    section: "Pentateuch",
    canonicalOrder: 4,
    scriptureChapters: 36,
  },
  {
    id: "deuteronomy",
    name: "Deuteronomy",
    testament: "ot",
    section: "Pentateuch",
    canonicalOrder: 5,
    scriptureChapters: 34,
  },
  {
    id: "joshua",
    name: "Joshua",
    testament: "ot",
    section: "Historical Books",
    canonicalOrder: 6,
    scriptureChapters: 24,
  },
  {
    id: "judges",
    name: "Judges",
    testament: "ot",
    section: "Historical Books",
    canonicalOrder: 7,
    scriptureChapters: 21,
  },
  {
    id: "ruth",
    name: "Ruth",
    testament: "ot",
    section: "Historical Books",
    canonicalOrder: 8,
    scriptureChapters: 4,
  },
  {
    id: "1-samuel",
    name: "1 Samuel",
    testament: "ot",
    section: "Historical Books",
    canonicalOrder: 9,
    scriptureChapters: 31,
  },
  {
    id: "2-samuel",
    name: "2 Samuel",
    testament: "ot",
    section: "Historical Books",
    canonicalOrder: 10,
    scriptureChapters: 24,
  },
  {
    id: "1-kings",
    name: "1 Kings",
    testament: "ot",
    section: "Historical Books",
    canonicalOrder: 11,
    scriptureChapters: 22,
  },
  {
    id: "2-kings",
    name: "2 Kings",
    testament: "ot",
    section: "Historical Books",
    canonicalOrder: 12,
    scriptureChapters: 25,
  },
  {
    id: "1-chronicles",
    name: "1 Chronicles",
    testament: "ot",
    section: "Historical Books",
    canonicalOrder: 13,
    scriptureChapters: 29,
  },
  {
    id: "2-chronicles",
    name: "2 Chronicles",
    testament: "ot",
    section: "Historical Books",
    canonicalOrder: 14,
    scriptureChapters: 36,
  },
  {
    id: "ezra",
    name: "Ezra",
    testament: "ot",
    section: "Historical Books",
    canonicalOrder: 15,
    scriptureChapters: 10,
  },
  {
    id: "nehemiah",
    name: "Nehemiah",
    testament: "ot",
    section: "Historical Books",
    canonicalOrder: 16,
    scriptureChapters: 13,
  },
  {
    id: "esther",
    name: "Esther",
    testament: "ot",
    section: "Historical Books",
    canonicalOrder: 17,
    scriptureChapters: 10,
  },
  {
    id: "job",
    name: "Job",
    testament: "ot",
    section: "Wisdom Literature",
    canonicalOrder: 18,
    scriptureChapters: 42,
  },
  {
    id: "psalms",
    name: "Psalms",
    testament: "ot",
    section: "Wisdom Literature",
    canonicalOrder: 19,
    scriptureChapters: 150,
  },
  {
    id: "proverbs",
    name: "Proverbs",
    testament: "ot",
    section: "Wisdom Literature",
    canonicalOrder: 20,
    scriptureChapters: 31,
  },
  {
    id: "ecclesiastes",
    name: "Ecclesiastes",
    testament: "ot",
    section: "Wisdom Literature",
    canonicalOrder: 21,
    scriptureChapters: 12,
  },
  {
    id: "song-of-songs",
    name: "Song of Songs",
    testament: "ot",
    section: "Wisdom Literature",
    canonicalOrder: 22,
    scriptureChapters: 8,
  },
  {
    id: "isaiah",
    name: "Isaiah",
    testament: "ot",
    section: "Major Prophets",
    canonicalOrder: 23,
    scriptureChapters: 66,
  },
  {
    id: "jeremiah",
    name: "Jeremiah",
    testament: "ot",
    section: "Major Prophets",
    canonicalOrder: 24,
    scriptureChapters: 52,
  },
  {
    id: "lamentations",
    name: "Lamentations",
    testament: "ot",
    section: "Major Prophets",
    canonicalOrder: 25,
    scriptureChapters: 5,
  },
  {
    id: "ezekiel",
    name: "Ezekiel",
    testament: "ot",
    section: "Major Prophets",
    canonicalOrder: 26,
    scriptureChapters: 48,
  },
  {
    id: "daniel",
    name: "Daniel",
    testament: "ot",
    section: "Major Prophets",
    canonicalOrder: 27,
    scriptureChapters: 12,
  },
  {
    id: "hosea",
    name: "Hosea",
    testament: "ot",
    section: "Minor Prophets",
    canonicalOrder: 28,
    scriptureChapters: 14,
  },
  {
    id: "joel",
    name: "Joel",
    testament: "ot",
    section: "Minor Prophets",
    canonicalOrder: 29,
    scriptureChapters: 3,
  },
  {
    id: "amos",
    name: "Amos",
    testament: "ot",
    section: "Minor Prophets",
    canonicalOrder: 30,
    scriptureChapters: 9,
  },
  {
    id: "obadiah",
    name: "Obadiah",
    testament: "ot",
    section: "Minor Prophets",
    canonicalOrder: 31,
    scriptureChapters: 1,
  },
  {
    id: "jonah",
    name: "Jonah",
    testament: "ot",
    section: "Minor Prophets",
    canonicalOrder: 32,
    scriptureChapters: 4,
  },
  {
    id: "micah",
    name: "Micah",
    testament: "ot",
    section: "Minor Prophets",
    canonicalOrder: 33,
    scriptureChapters: 7,
  },
  {
    id: "nahum",
    name: "Nahum",
    testament: "ot",
    section: "Minor Prophets",
    canonicalOrder: 34,
    scriptureChapters: 3,
  },
  {
    id: "habakkuk",
    name: "Habakkuk",
    testament: "ot",
    section: "Minor Prophets",
    canonicalOrder: 35,
    scriptureChapters: 3,
  },
  {
    id: "zephaniah",
    name: "Zephaniah",
    testament: "ot",
    section: "Minor Prophets",
    canonicalOrder: 36,
    scriptureChapters: 3,
  },
  {
    id: "haggai",
    name: "Haggai",
    testament: "ot",
    section: "Minor Prophets",
    canonicalOrder: 37,
    scriptureChapters: 2,
  },
  {
    id: "zechariah",
    name: "Zechariah",
    testament: "ot",
    section: "Minor Prophets",
    canonicalOrder: 38,
    scriptureChapters: 14,
  },
  {
    id: "malachi",
    name: "Malachi",
    testament: "ot",
    section: "Minor Prophets",
    canonicalOrder: 39,
    scriptureChapters: 4,
  },
  {
    id: "matthew",
    name: "Matthew",
    testament: "nt",
    section: "Gospels",
    canonicalOrder: 40,
    scriptureChapters: 28,
  },
  {
    id: "mark",
    name: "Mark",
    testament: "nt",
    section: "Gospels",
    canonicalOrder: 41,
    scriptureChapters: 16,
  },
  {
    id: "luke",
    name: "Luke",
    testament: "nt",
    section: "Gospels",
    canonicalOrder: 42,
    scriptureChapters: 24,
  },
  {
    id: "john",
    name: "John",
    testament: "nt",
    section: "Gospels",
    canonicalOrder: 43,
    scriptureChapters: 21,
  },
  {
    id: "acts",
    name: "Acts",
    testament: "nt",
    section: "Acts",
    canonicalOrder: 44,
    scriptureChapters: 28,
  },
  {
    id: "romans",
    name: "Romans",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 45,
    scriptureChapters: 16,
  },
  {
    id: "1-corinthians",
    name: "1 Corinthians",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 46,
    scriptureChapters: 16,
  },
  {
    id: "2-corinthians",
    name: "2 Corinthians",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 47,
    scriptureChapters: 13,
  },
  {
    id: "galatians",
    name: "Galatians",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 48,
    scriptureChapters: 6,
  },
  {
    id: "ephesians",
    name: "Ephesians",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 49,
    scriptureChapters: 6,
  },
  {
    id: "philippians",
    name: "Philippians",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 50,
    scriptureChapters: 4,
  },
  {
    id: "colossians",
    name: "Colossians",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 51,
    scriptureChapters: 4,
  },
  {
    id: "1-thessalonians",
    name: "1 Thessalonians",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 52,
    scriptureChapters: 5,
  },
  {
    id: "2-thessalonians",
    name: "2 Thessalonians",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 53,
    scriptureChapters: 3,
  },
  {
    id: "1-timothy",
    name: "1 Timothy",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 54,
    scriptureChapters: 6,
  },
  {
    id: "2-timothy",
    name: "2 Timothy",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 55,
    scriptureChapters: 4,
  },
  {
    id: "titus",
    name: "Titus",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 56,
    scriptureChapters: 3,
  },
  {
    id: "philemon",
    name: "Philemon",
    testament: "nt",
    section: "Pauline Epistles",
    canonicalOrder: 57,
    scriptureChapters: 1,
  },
  {
    id: "hebrews",
    name: "Hebrews",
    testament: "nt",
    section: "General Epistles",
    canonicalOrder: 58,
    scriptureChapters: 13,
  },
  {
    id: "james",
    name: "James",
    testament: "nt",
    section: "General Epistles",
    canonicalOrder: 59,
    scriptureChapters: 5,
  },
  {
    id: "1-peter",
    name: "1 Peter",
    testament: "nt",
    section: "General Epistles",
    canonicalOrder: 60,
    scriptureChapters: 5,
  },
  {
    id: "2-peter",
    name: "2 Peter",
    testament: "nt",
    section: "General Epistles",
    canonicalOrder: 61,
    scriptureChapters: 3,
  },
  {
    id: "1-john",
    name: "1 John",
    testament: "nt",
    section: "General Epistles",
    canonicalOrder: 62,
    scriptureChapters: 5,
  },
  {
    id: "2-john",
    name: "2 John",
    testament: "nt",
    section: "General Epistles",
    canonicalOrder: 63,
    scriptureChapters: 1,
  },
  {
    id: "3-john",
    name: "3 John",
    testament: "nt",
    section: "General Epistles",
    canonicalOrder: 64,
    scriptureChapters: 1,
  },
  {
    id: "jude",
    name: "Jude",
    testament: "nt",
    section: "General Epistles",
    canonicalOrder: 65,
    scriptureChapters: 1,
  },
  {
    id: "revelation",
    name: "Revelation",
    testament: "nt",
    section: "Revelation",
    canonicalOrder: 66,
    scriptureChapters: 22,
  },
] as const;

export const BOOK_BY_ID: Record<BibleBookId, BibleBookMeta> = Object.fromEntries(
  PROTESTANT_BOOKS.map((book) => [book.id, book]),
) as Record<BibleBookId, BibleBookMeta>;

export const PROTESTANT_BOOK_IDS: readonly BibleBookId[] = PROTESTANT_BOOKS.map((book) => book.id);
